//-------------------- Room Studio JS-------------------- // 


(() => {
  'use strict';

  const initCSPRoomStudio = (scope = document) => {
    const sections = [];

    if (
      scope instanceof Element &&
      scope.matches('[data-csp-room-studio]')
    ) {
      sections.push(scope);
    }

    scope.querySelectorAll?.('[data-csp-room-studio]').forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      if (section.dataset.cspModalInitialized === 'true') return;

      const find = (selector) => section.querySelector(selector);

      const modal = find('[data-csp-modal]');
      const dialog = find('[data-csp-dialog]');
      const image = find('[data-csp-modal-image]');
      const imageWrap = find('[data-csp-modal-image-wrap]');
      const tag = find('[data-csp-modal-tag]');
      const title = find('[data-csp-modal-title]');
      const price = find('[data-csp-modal-price]');
      const compare = find('[data-csp-modal-compare]');
      const discount = find('[data-csp-modal-discount]');
      const description = find('[data-csp-modal-description]');
      const variant = find('[data-csp-modal-variant]');
      const cartButton = find('[data-csp-cart-button]');
      const closeButton = find('[data-csp-close]');
      const cartForm = find('[data-csp-cart-form]');
      const viewDetailsButton = find('[data-csp-view-details]');

      const required = {
        modal,
        dialog,
        image,
        imageWrap,
        tag,
        title,
        price,
        compare,
        discount,
        description,
        variant,
        cartButton,
        closeButton,
        cartForm
      };

      const missing = Object.entries(required)
        .filter(([, element]) => !element)
        .map(([name]) => name);

      if (missing.length) {
        console.error(
          'CSP Room Studio: missing elements:',
          missing.join(', ')
        );
        return;
      }

      const pins = section.querySelectorAll('[data-csp-pin]');

      let lastPin = null;
      let addingToCart = false;

      /* Update cart count in the header */
      const updateCartCount = (count) => {
        document.querySelectorAll(
          '[data-csa-cart-count], [data-cart-count-bubble]'
        ).forEach((element) => {
          element.textContent = count;
          element.hidden = count <= 0;
        });
      };

      /* Refresh Shopify cart count */
      const refreshCartCount = async () => {
        const root = window.Shopify?.routes?.root || '/';

        const response = await fetch(`${root}cart.js`, {
          headers: {
            Accept: 'application/json'
          },
          credentials: 'same-origin'
        });

        if (!response.ok) return;

        const cart = await response.json();

        updateCartCount(cart.item_count);
      };

      /* Close product modal */
      const closeModal = () => {
        if (!modal.classList.contains('is-open')) return;

        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');

        document.documentElement.classList.remove(
          'CSP-room-studio-modal-open'
        );

        pins.forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });

        if (lastPin && document.contains(lastPin)) {
          lastPin.focus({
            preventScroll: true
          });
        }
      };

      /* Open product modal */
      const openModal = (pin) => {
        lastPin = pin;

        /* Product title */
        title.textContent = pin.dataset.productTitle || '';

        /* Product tag */
        tag.textContent = pin.dataset.productTag || '';
        tag.hidden = !tag.textContent;

        /* Product price */
        price.textContent = pin.dataset.productPrice || '';

        /* Compare-at price */
        compare.textContent = pin.dataset.productCompare || '';
        compare.hidden = !compare.textContent;

        /* Discount percentage */
        const discountValue = pin.dataset.productDiscount || '';

        discount.textContent =
          compare.textContent && discountValue
            ? `${discountValue}% OFF`
            : '';

        discount.hidden = !discount.textContent;

        /* Product description */
        description.textContent =
          pin.dataset.productDescription || '';

        description.hidden = !description.textContent;

        /*
         * Description length is controlled through CSS.
         * Only two lines will be displayed.
         */

        /* Product image */
        if (pin.dataset.productImage) {
          image.src = pin.dataset.productImage;

          image.alt =
            pin.dataset.productImageAlt ||
            pin.dataset.productTitle ||
            '';

          imageWrap.hidden = false;
        } else {
          image.removeAttribute('src');
          image.alt = '';
          imageWrap.hidden = true;
        }

        /* Product-specific View Details link */
        const productUrl = pin.dataset.productUrl || '';

        if (viewDetailsButton) {
          if (productUrl) {
            viewDetailsButton.href = productUrl;
            viewDetailsButton.hidden = false;
          } else {
            viewDetailsButton.removeAttribute('href');
            viewDetailsButton.hidden = true;
          }
        }

        /* Selected product variant */
        const variantId = pin.dataset.productVariant || '';
        const available = pin.dataset.productAvailable === 'true';

        variant.value = variantId;

        cartButton.disabled = !available || !variantId;

        cartButton.textContent = available
          ? section.dataset.cspAddText || 'Add to Shopping Bag'
          : section.dataset.cspSoldText || 'Sold Out';

        /* Open modal */
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');

        document.documentElement.classList.add(
          'CSP-room-studio-modal-open'
        );

        pins.forEach((button) => {
          button.setAttribute(
            'aria-expanded',
            String(button === pin)
          );
        });

        closeButton.focus({
          preventScroll: true
        });
      };

      /* Product pin and modal close clicks */
      section.addEventListener('click', (event) => {
        const target =
          event.target instanceof Element ? event.target : null;

        if (!target) return;

        const pin = target.closest('[data-csp-pin]');

        if (pin && section.contains(pin)) {
          event.preventDefault();
          event.stopPropagation();

          openModal(pin);
          return;
        }

        if (
          target.closest('[data-csp-close], [data-csp-backdrop]')
        ) {
          event.preventDefault();
          closeModal();
        }
      });

      /* Close when clicking the modal background */
      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          closeModal();
        }
      });

      /* Close modal using Escape */
      const handleEscape = (event) => {
        if (
          modal.classList.contains('is-open') &&
          event.key === 'Escape'
        ) {
          closeModal();
        }
      };

      document.addEventListener('keydown', handleEscape);

      /* AJAX ADD TO CART */
      cartForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (addingToCart || cartButton.disabled) return;

        addingToCart = true;

        const originalText = cartButton.textContent;

        cartButton.disabled = true;
        cartButton.textContent = 'Adding...';

        try {
          const root = window.Shopify?.routes?.root || '/';

          const formData = new FormData(cartForm);

          formData.set('id', variant.value);
          formData.set(
            'quantity',
            formData.get('quantity') || '1'
          );

          formData.set(
            'sections',
            'cart-drawer,cart-icon-bubble'
          );

          formData.set(
            'sections_url',
            window.location.pathname
          );

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: formData,
            credentials: 'same-origin'
          });

          const result = await response.json();

          if (!response.ok) {
            throw new Error(
              result.description ||
              result.message ||
              'Unable to add product to cart.'
            );
          }

          /* Refresh cart count */
          try {
            await refreshCartCount();
          } catch (countError) {
            console.warn(
              'CSP Room Studio: could not refresh cart count.',
              countError
            );
          }

          /* Close popup after successful add */
          closeModal();

          /* Refresh and open Shopify cart drawer */
          const drawer = document.querySelector('cart-drawer');

          if (drawer && typeof drawer.open === 'function') {
            if (
              result.sections &&
              typeof drawer.renderContents === 'function'
            ) {
              try {
                drawer.renderContents(result);
              } catch (drawerError) {
                console.warn(
                  'CSP Room Studio: could not refresh cart drawer.',
                  drawerError
                );

                drawer.open();
              }
            } else {
              drawer.open();
            }
          }

          /* Notify other theme scripts */
          document.dispatchEvent(
            new CustomEvent('cart:updated')
          );

          cartButton.textContent = 'Added!';

        } catch (error) {
          console.error(
            'CSP Room Studio Add to Cart:',
            error
          );

          cartButton.textContent =
            error.message || 'Please try again';

        } finally {
          addingToCart = false;

          /*
           * Restore the button according to the selected
           * product's actual availability.
           */
          const currentPin = lastPin;

          const isAvailable =
            currentPin?.dataset.productAvailable === 'true';

          const currentVariantId =
            currentPin?.dataset.productVariant || '';

          cartButton.disabled =
            !isAvailable || !currentVariantId;

          window.setTimeout(() => {
            if (!modal.classList.contains('is-open')) {
              cartButton.textContent = originalText;
              return;
            }

            cartButton.textContent =
              isAvailable
                ? section.dataset.cspAddText || 'Add to Shopping Bag'
                : section.dataset.cspSoldText || 'Sold Out';
          }, 1800);
        }
      });

      section.dataset.cspModalInitialized = 'true';

      console.info(
        'CSP Room Studio initialized:',
        pins.length,
        'pins'
      );
    });
  };

  const startCSPRoomStudio = () => {
    initCSPRoomStudio(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startCSPRoomStudio,
      {
        once: true
      }
    );
  } else {
    startCSPRoomStudio();
  }

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', (event) => {
    initCSPRoomStudio(event.target);
  });
})();



// -------------------Indian Collection JS---------------- //


(() => {
  'use strict';

  const initCIPSection = (scope = document) => {
    const sections = [];

    if (
      scope instanceof Element &&
      scope.matches('[data-cip-section]')
    ) {
      sections.push(scope);
    }

    scope.querySelectorAll?.('[data-cip-section]').forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      if (section.dataset.cipInitialized === 'true') return;

      const find = (selector) => section.querySelector(selector);

      const modal = find('[data-cip-modal]');
      const dialog = find('[data-cip-dialog]');
      const modalImage = find('[data-cip-image]');
      const imageWrap = find('[data-cip-image-wrap]');
      const modalTag = find('[data-cip-tag]');
      const modalTitle = find('[data-cip-title]');
      const modalPrice = find('[data-cip-price]');
      const modalCompare = find('[data-cip-compare]');
      const modalDiscount = find('[data-cip-discount]');
      const modalDescription = find('[data-cip-description]');
      const modalVariant = find('[data-cip-variant]');
      const modalCart = find('[data-cip-cart]');
      const viewDetailsButton = find('[data-cip-view-details]');

      if (
        !modal ||
        !dialog ||
        !modalImage ||
        !imageWrap ||
        !modalTag ||
        !modalTitle ||
        !modalPrice ||
        !modalCompare ||
        !modalDiscount ||
        !modalDescription ||
        !modalVariant ||
        !modalCart ||
        !viewDetailsButton
      ) {
        console.error('CIP: Required modal elements are missing.');
        return;
      }

      let lastTrigger = null;
      let cartRequestInProgress = false;

      /* Update cart count */
      const updateCartCount = (count) => {
        document.querySelectorAll(
          '[data-csa-cart-count], [data-cart-count-bubble]'
        ).forEach((badge) => {
          badge.textContent = count;
          badge.hidden = count <= 0;
        });
      };

      /* Refresh cart count */
      const refreshCartCount = async () => {
        try {
          const root = window.Shopify?.routes?.root || '/';

          const response = await fetch(`${root}cart.js`, {
            headers: {
              Accept: 'application/json'
            },
            credentials: 'same-origin'
          });

          if (!response.ok) return;

          const cart = await response.json();

          updateCartCount(cart.item_count);
        } catch (error) {
          console.error('CIP: Cart count refresh failed.', error);
        }
      };

      /* Open Shopify cart drawer */
      const openCartDrawer = (cartData) => {
        const cartDrawer = document.querySelector('cart-drawer');

        if (!cartDrawer || typeof cartDrawer.open !== 'function') {
          console.warn(
            'CIP: Dawn cart drawer not found.'
          );
          return;
        }

        if (
          cartData?.sections &&
          typeof cartDrawer.renderContents === 'function'
        ) {
          try {
            cartDrawer.renderContents(cartData);
            return;
          } catch (error) {
            console.error('CIP: Drawer refresh failed.', error);
          }
        }

        cartDrawer.open();
      };

      /* Close modal */
      const closeModal = () => {
        if (!modal.classList.contains('is-open')) return;

        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');

        document.documentElement.classList.remove('CIP-modal-open');

        if (lastTrigger && document.contains(lastTrigger)) {
          lastTrigger.focus({
            preventScroll: true
          });
        }
      };

      /* AJAX add to cart */
      const addToCart = async (form, button) => {
        if (cartRequestInProgress || button.disabled) return;

        const variantInput = form.querySelector('[name="id"]');

        if (!variantInput?.value) {
          console.error('CIP: Variant ID missing.');
          return;
        }

        const originalText = button.textContent.trim();

        cartRequestInProgress = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding...';

        try {
          const formData = new FormData(form);

          formData.set('id', variantInput.value);
          formData.set(
            'quantity',
            formData.get('quantity') || '1'
          );

          formData.set(
            'sections',
            'cart-drawer,cart-icon-bubble'
          );

          formData.set(
            'sections_url',
            window.location.pathname
          );

          const root = window.Shopify?.routes?.root || '/';

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: formData,
            credentials: 'same-origin'
          });

          const result = await response.json();

          if (!response.ok) {
            throw new Error(
              result.description ||
              result.message ||
              'Unable to add product.'
            );
          }

          await refreshCartCount();

          if (modal.contains(form)) {
            closeModal();
          }

          openCartDrawer(result);

          document.dispatchEvent(
            new CustomEvent('cart:updated')
          );

          button.textContent = 'Added!';

        } catch (error) {
          console.error('CIP: Add to cart failed.', error);

          button.textContent =
            error.message || 'Please try again';

          window.setTimeout(() => {
            button.textContent = originalText;
          }, 2500);

        } finally {
          cartRequestInProgress = false;
          button.removeAttribute('aria-busy');

          if (button.textContent === 'Adding...') {
            button.disabled = false;
            button.textContent = originalText;
          } else if (button.textContent === 'Added!') {
            button.disabled = false;

            window.setTimeout(() => {
              button.textContent = originalText;
            }, 1500);
          } else {
            button.disabled = false;
          }
        }
      };

      /* Open product quick-view modal */
      const openModal = (button) => {
        lastTrigger = button;

        modalTitle.textContent =
          button.dataset.productTitle || '';

        modalTag.textContent =
          button.dataset.productTag || '';

        modalTag.hidden = !modalTag.textContent;

        modalPrice.textContent =
          button.dataset.productPrice || '';

        modalCompare.textContent =
          button.dataset.productCompare || '';

        modalCompare.hidden = !modalCompare.textContent;

        const discountValue =
          button.dataset.productDiscount || '';

        modalDiscount.textContent =
          modalCompare.textContent && discountValue
            ? `${discountValue}% OFF`
            : '';

        modalDiscount.hidden = !modalDiscount.textContent;

        modalDescription.textContent =
          button.dataset.productDescription || '';

        modalDescription.hidden = !modalDescription.textContent;

        /* Description is limited to two lines by CSS */

        /* Product image */
        if (button.dataset.productImage) {
          modalImage.src = button.dataset.productImage;

          modalImage.alt =
            button.dataset.productImageAlt ||
            button.dataset.productTitle ||
            '';

          imageWrap.hidden = false;
        } else {
          modalImage.removeAttribute('src');
          modalImage.alt = '';
          imageWrap.hidden = true;
        }

        /* Product-specific View Details URL */
        const productUrl = button.dataset.productUrl || '';

        if (productUrl) {
          viewDetailsButton.href = productUrl;
          viewDetailsButton.hidden = false;
        } else {
          viewDetailsButton.removeAttribute('href');
          viewDetailsButton.hidden = true;
        }

        /* Variant and availability */
        const variantId =
          button.dataset.productVariant || '';

        const available =
          button.dataset.productAvailable === 'true';

        modalVariant.value = variantId;

        modalCart.disabled = !available || !variantId;

        modalCart.textContent = available
          ? section.querySelector('[data-cip-quick-view]')
              ?.closest('[data-cip-section]')
              ?.dataset.cipAddText || 'Add To Cart'
          : 'Sold Out';

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');

        document.documentElement.classList.add('CIP-modal-open');

        const closeButton = modal.querySelector('[data-cip-close]');

        closeButton?.focus({
          preventScroll: true
        });
      };

      /* Handle cart submissions without page redirect */
      section.addEventListener('submit', (event) => {
        const form = event.target;

        if (
          !(form instanceof HTMLFormElement) ||
          !form.matches('.CIP-cart-form, .CIP-modal-cart-form')
        ) {
          return;
        }

        event.preventDefault();

        const button =
          event.submitter ||
          form.querySelector('[type="submit"]');

        if (button) {
          addToCart(form, button);
        }
      });

      /* Tabs, quick view, wishlist and product cards */
      section.addEventListener('click', (event) => {
        const target =
          event.target instanceof Element
            ? event.target
            : null;

        if (!target) return;

        /* Category tabs */
        const tab = target.closest('[data-cip-category]');

        if (tab && section.contains(tab)) {
          event.preventDefault();

          const category = tab.dataset.cipCategory;

          section.querySelectorAll('[data-cip-category]').forEach((item) => {
            const active = item === tab;

            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', String(active));
          });

          section.querySelectorAll('[data-cip-grid]').forEach((grid) => {
            grid.hidden = grid.dataset.cipGrid !== category;
          });

          return;
        }

        /* Close modal */
        const closeControl = target.closest('[data-cip-close]');

        if (closeControl && modal.contains(closeControl)) {
          event.preventDefault();
          closeModal();
          return;
        }

        /* Quick View */
        const quickView = target.closest('[data-cip-quick-view]');

        if (quickView && section.contains(quickView)) {
          event.preventDefault();
          event.stopPropagation();

          openModal(quickView);
          return;
        }

        /* Wishlist */
        const wishlist = target.closest('[data-cip-wishlist]');

        if (wishlist && section.contains(wishlist)) {
          event.preventDefault();

          const active = wishlist.classList.toggle('is-active');

          wishlist.setAttribute('aria-pressed', String(active));

          wishlist.setAttribute(
            'aria-label',
            active
              ? 'Remove from wishlist'
              : 'Add to wishlist'
          );

          return;
        }

        /* Mobile product-card quick view */
        const card = target.closest('.CIP-card');

        if (card && section.contains(card)) {
          const interactive = target.closest(
            'button, form, input, select, textarea, [data-cip-wishlist], a'
          );

          if (interactive) return;

          const productButton =
            card.querySelector('[data-cip-quick-view]');

          if (productButton) {
            event.preventDefault();
            event.stopPropagation();

            openModal(productButton);
          }
        }
      });

      /* Close when clicking modal outer area */
      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          closeModal();
        }
      });

      /* Escape key closes modal */
      document.addEventListener('keydown', (event) => {
        if (
          modal.classList.contains('is-open') &&
          event.key === 'Escape'
        ) {
          closeModal();
        }
      });

      section.dataset.cipInitialized = 'true';

      console.info('CIP section initialized.');
    });
  };

  const startCIPSection = () => {
    initCIPSection(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startCIPSection,
      { once: true }
    );
  } else {
    startCIPSection();
  }

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', (event) => {
    initCIPSection(event.target);
  });
})();



//-------------------- Whatsapp Widget-------------------- // 



(function () {
  'use strict';

  function initCWP() {
    document.querySelectorAll('[data-cwp]').forEach(function (widget) {
      if (widget.dataset.cwpInitialized === 'true') return;
      widget.dataset.cwpInitialized = 'true';

      const link = widget.querySelector('[data-cwp-link]');
      if (!link) return;

      link.addEventListener('click', function (event) {
        const phone = (widget.dataset.phone || '').replace(/\D/g, '');

        if (!phone || phone.length < 10) {
          event.preventDefault();
          return;
        }

        event.preventDefault();

        const message =
          widget.dataset.message ||
          'Hello! I would like more information.';

        const fullMessage =
          message + '\n\nPage link: ' + window.location.href;

        const whatsappUrl =
          'https://wa.me/' + phone +
          '?text=' + encodeURIComponent(fullMessage);

        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCWP, { once: true });
  } else {
    initCWP();
  }

  document.addEventListener('shopify:section:load', initCWP);
})();
